"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.disconnectWeb3 = exports.ethConnect = exports.checkAndSignAuthMessage = void 0;
const tslib_1 = require("tslib");
const _LitNodeClient = require("./lib/lit-node-client");
const LitNodeClient = _LitNodeClient.LitNodeClient;
if (!globalThis.LitNodeClient) {
    globalThis.LitNodeClient = LitNodeClient;
}
// ==================== Exports ====================
tslib_1.__exportStar(require("./lib/lit-node-client"), exports);
var auth_browser_1 = require("@lit-protocol/auth-browser");
Object.defineProperty(exports, "checkAndSignAuthMessage", { enumerable: true, get: function () { return auth_browser_1.checkAndSignAuthMessage; } });
Object.defineProperty(exports, "ethConnect", { enumerable: true, get: function () { return auth_browser_1.ethConnect; } });
Object.defineProperty(exports, "disconnectWeb3", { enumerable: true, get: function () { return auth_browser_1.disconnectWeb3; } });
tslib_1.__exportStar(require("@lit-protocol/lit-node-client-nodejs"), exports);
//# sourceMappingURL=index.js.map